import $ from 'jquery';
import Radio from 'backbone.radio';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import home_template from '@/../templates/ide-home.hbs';
import BreadcrumbNavLayout from '@/views/breadcrumb_nav_layout';

var globalCh = Radio.channel('global');

function home() {
    var options = globalCh.request('app_options');
    var ide_settings = globalCh.request('ide_settings');

    $('.devices-container').removeClass('allHidden');
    // Navigating from the Migration Layout made this break
    // Deserving of a better fix. This seems awkward. Can Migration
    // Layout be bettered
    var app_layout = globalCh.request('app_layout');
    app_layout.showChildView('main_nav', new BreadcrumbNavLayout() );

    globalCh.request('set_selection', {
        type: 'app',
        id: 'home'
    });

    var view = new Marionette.View({
        template : Handlebars.compile(home_template)
    });

    // Show view in app container region
    var container_region = globalCh.request('app_layout').getRegion('container');
    container_region.show(view);

    // Show appropriate dialogs based on ide settings. Using 'new_user ' as the variable

    function show_new_user() {
        if (ide_settings.get('new_user')) {
            globalCh.request('showNewUserImpCentralCarousel');
            ide_settings.set('new_user', false);
            ide_settings.save();
        }
    }

    ide_settings.fetch().done(show_new_user);

    // if present, show correct title from config
    if (options.theme && options.theme.app_title) {
        document.title = options.theme.app_title;
    } else {
        document.title = "impCentral | Electric Imp";
    }

    /*
        Initial Routing for all roles
    */
    return globalCh.request('showProducts');
}

export default home;

